import React, { useMemo } from 'react';
import { ProfileTaxModal1 } from './modals/ProfileTaxModal1';
import { ProfileTaxModal5 } from './modals/ProfileTaxModal5';
import { ProfileTaxModal6 } from './modals/ProfileTaxModal6';
import { useHasState } from './hooks/useHasState';
import { useUserField } from '../userFields/useUserField';

export const ProfileTaxModalDispatcher: React.FC = () => {
    const { getField } = useUserField();

    const { hasState } = useHasState();

    const currentState = useMemo(() => {
        return getField('Invoice_Tax_State');
    }, [getField]);

    const shouldShow = useMemo(() => {
        return ['1', '2', '3', '4', '5', '6', '7'].includes(currentState);
    }, [currentState]);

    return (
        <>
            {shouldShow && (
                <>
                    {hasState([1]) && <ProfileTaxModal1 />}
                    {hasState([5]) && <ProfileTaxModal5 />}
                    {hasState([6]) && <ProfileTaxModal6 />}
                </>
            )}
        </>
    );
};
